import styled from "@emotion/styled";

export const StyledGridTag = styled.div`
  display: flex;
  flex-direction: column;

  .tag-component-wrapper {
    display: flex;
  }
`;
